'use strict';

import './misc.css';
import './callouts.css';
import './inputs.css';
import './locations.css';
import './log.css';
import './team.css';
import './forms.css';
import './modals.css';
import './text.css';
import './toastr.css';
import './manager-toolbar.css';
import './incident-lists.css';
import './incident-cards.css';
import './animations.css';
import './tables.css';
import './labels.css';
import panelsModule from './panels';

const MODULE_NAME = 'daupler.incidents.style';

angular.module(MODULE_NAME, [
	panelsModule,
]);

export default MODULE_NAME;
